<template>
    <div>
        <div class="columns" v-if="bundle !== null">
            <div class="column is-6">
                <bundle-form :bundle="bundle" @saved="reloadBundle"></bundle-form>
            </div>
            <div class="column is-6">
                <bundle-products :bundle-id="bundle.id"></bundle-products>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                bundle_id: parseInt(this.$route.params.id),
                bundle: null,
            }
        },
        computed: Object.assign({}, mapGetters(['bundles', 'products']), {
            linkedProducts() {
                let links = this.$store.state.products.product_bundles.filter(item => item.bundle_id === this.bundle_id)
                let ids   = []
                for (let link in links) {
                    ids.push(links[link].product_id)
                }

                return this.products.filter(product => ids.indexOf(product.id) !== -1)
            },
        }),
        mounted() {
            this.reloadBundle();
        },
        methods: {
            changeBundle(newId, oldId) {
                this.bundle_id = parseInt(newId)
                this.reloadBundle()
            },
            reloadBundle() {
                this.bundle = null;
                setTimeout(() => {
                    this.bundle = this.$store.state.products.bundles.find(bundle => bundle.id === this.bundle_id)
                })
            }
        },
        watch: {
            '$route.params.id': 'changeBundle'
        }
    };
</script>



// WEBPACK FOOTER //
// BundleEdit.vue?442c9606